import { defineClassNames } from '../../../utils/defineClassNames';

export const classes = defineClassNames('side-panel-footer', {
  root: {},
  footerContainer: { states: ['noPadding'] },
  divider: {},
});
